import { createSlice } from '@reduxjs/toolkit';
import { subscribeEmail } from './EmailSubscription';
const initialState = {
  email: '',
  loading: false,
  error: null,
};
const subscriptionSlice = createSlice({
  name: 'subscription',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(subscribeEmail.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(subscribeEmail.fulfilled, (state, action) => {
        state.loading = false;
        state.email = action.payload.email;
      })
      .addCase(subscribeEmail.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default subscriptionSlice.reducer;